export default "__VITE_ASSET__DGxb$4jh__"